module.exports = __webpack_public_path__ + "img/women-with-tab.5d40d9a4.png";